import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, map, tap, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ResponseTerceros, TerceroById } from '../interfaces/terceros.interface';
import { CoreService } from 'src/app/shared/services/core-service.service';

@Injectable({
  providedIn: 'root'
})
export class TercerosService {

  private baseUrl: string = environment.baseUrlAuth;

  private http          = inject(HttpClient);
  private _coreService  = inject(CoreService);


  getTercerosById(typeId: string,id: string): Observable<ResponseTerceros> {
    const authToken = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    });

    return this.http.get<ResponseTerceros>(`${this.baseUrl}/api/terceros/${typeId}/${id}`, { headers })
      .pipe(
        // tap((response: TerceroById[] | any) => console.log(response)),
        map((response: ResponseTerceros) => response),
        catchError(err => {
          this._coreService.openErrorSnackbar(`${err.error.message}`, 'Ok');
          console.error(err.error);
          return throwError(() => err)
        })
      );
  }


}
